import { Stack, Text } from '@fluentui/react'
import { Pie } from 'react-chartjs-2'
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js'
import { QuestionsByPlanItem } from '../../api/models'

ChartJS.register(ArcElement, Tooltip, Legend)

type QuestionsByPlanChartProps = {
  data: QuestionsByPlanItem[] | null
}

const cardStyle = {
  root: {
    padding: '24px',
    backgroundColor: '#fff',
    borderRadius: 8,
    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
    flex: 1,
    minWidth: 300,
  },
}

const COLORS = [
  '#2B3A67',
  '#496A99',
  '#8BACC4',
  '#C5D5E4',
  '#B8C47E',
  '#C8C1B1',
  '#5B8A72',
  '#D4775B',
  '#3D5A80',
  '#A4C2A5',
]

const QuestionsByPlanChart = ({ data }: QuestionsByPlanChartProps) => {
  if (!data || data.length === 0) return null

  const chartData = {
    labels: data.map((d) => d.plan_name),
    datasets: [
      {
        data: data.map((d) => d.count),
        backgroundColor: data.map((_, i) => COLORS[i % COLORS.length]),
        borderWidth: 1,
        borderColor: '#fff',
      },
    ],
  }

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'right' as const,
      },
    },
  }

  return (
    <Stack styles={cardStyle} tokens={{ childrenGap: 12 }}>
      <Text variant="mediumPlus" styles={{ root: { fontWeight: 600, color: '#605e5c' } }}>
        Questions by Organization
      </Text>
      <div style={{ height: 280 }}>
        <Pie data={chartData} options={options} />
      </div>
    </Stack>
  )
}

export default QuestionsByPlanChart
